import * as React from "react";
import {Action, Dispatch} from "redux";
import {connect} from "react-redux";

import {AppState} from "../store/app_state";

import {createClientClientBookmarksDispatcher, IClientClientBookmarksDispatcher} from "../dispatcher/client_client_bookmarks_dispatcher";
import {createClientClientBookmarksActionCreator} from "../action/client_client_bookmarks_action";
import ClientClientBookmarksComponent from "../component/client/client_bookmarks/client_bookmarks";
import {GetAllClientBookmarkByClientRequest} from "../request/client_bookmark_request";
import {ClientClientBookmarksState} from "../store/client_client_bookmarks_state";

interface IProps {
    state: ClientClientBookmarksState
    dispatcher: IClientClientBookmarksDispatcher;
}

interface IState {
    isInit: boolean;
}

export class ClientClientBookmarks extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

    };
    
    public componentDidMount() {
        const req: GetAllClientBookmarkByClientRequest = new GetAllClientBookmarkByClientRequest();
        this.props.dispatcher.getAllClientBookmarks(req);
    }

    public render (): JSX.Element {

        const {clientBookmarks, customers, jobCareersWithCustomerID, isLoading} = this.props.state;

        let res: JSX.Element;

        res = <ClientClientBookmarksComponent
            clientBookmarks={clientBookmarks}
            customers={customers}
            jobCareersWithCustomerID={jobCareersWithCustomerID}
            isLoading={isLoading}
        />;

        return (res)
    }

}

const mapStateToProps = (state: AppState) => {
    return {
        state: state.clientClientBookmarksReducer,
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
    return {
        dispatcher: createClientClientBookmarksDispatcher(dispatch, createClientClientBookmarksActionCreator()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ClientClientBookmarks);



// WEBPACK FOOTER //
// ./src/presentation/container/client_client_bookmarks_container.tsx